import { VehiculeCheckFilterType } from '@/entities/vehicle';
import { TVehiculeCheckSchema } from '@/schemas/vehicule-check/vehicule-check.schema';
import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { mapVehicleFilterAPI } from '@/utils/map.utils';
import { TotalActiveVehiculeCheck } from '../entities/vehicule-check';

const VEHICULE_CHECK_URI = '/vehiculeCheck';

export const createNewVehiculeCheck = async (
  vehicule: TVehiculeCheckSchema
) => {
  return requestApi({
    url: VEHICULE_CHECK_URI,
    method: HTTP_METHOD.POST,
    body: vehicule,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getExistingVehiculeCheck = async (
  query?: TVehiculeCheckSchema
) => {
  let url = `${VEHICULE_CHECK_URI}/existing`;
  const params = new URLSearchParams();

  if (query?.id) {
    params.append('id', query.id);
  }

  if (query?.referenceNumber) {
    params.append('referenceNumber', query.referenceNumber);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeChecks = async (
  filter: VehiculeCheckFilterType,
  page: number,
  limit: number,
  sortBy?: string,
  sortDirection?: 'asc' | 'desc'
) => {
  let url = `${VEHICULE_CHECK_URI}/get/all?${mapVehicleFilterAPI(
    filter
  )}&page=${page}&limit=${limit}`;

  // Add sort parameters if provided
  if (sortBy) {
    url += `&sortBy=${sortBy}&sortDirection=${sortDirection || 'asc'}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getTotalActiveVehiculeChecks = async (
  query?: TotalActiveVehiculeCheck
) => {
  let url = `${VEHICULE_CHECK_URI}/totalActive`;

  if (query?.vehiculeId) {
    url += `?vehiculeId=${query?.vehiculeId}`;
  }

  if (query?.actionUserId) {
    url += `?actionUserId=${query?.actionUserId}`;
  }

  if (query?.userId) {
    url += `?userId=${query?.userId}`;
  }

  return requestApi({
    url,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getVehiculeCheckById = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/get/${id}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeChecksByActionUserId = async (
  actionUserId: string
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/actionUser/${actionUserId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getCreatedVehiculeChecksPerMonth = async (userId?: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/stats/createdPerMonth${
      userId ? `?userId=${userId}` : ''
    }`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeChecksToModerate = async (userId?: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/get/all/toModerate${
      userId ? `?userId=${userId}` : ''
    }`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllVehiculeChecksToValidate = async (userId?: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/get/all/toValidate${
      userId ? `?userId=${userId}` : ''
    }`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateVehiculeCheck = async (
  vehiculeCheck: TVehiculeCheckSchema
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: vehiculeCheck,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const validateModeration = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/validate-moderation/${id}`,
    method: HTTP_METHOD.PATCH,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteVehiculeCheck = async (id: string) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/delete/${id}`,
    method: HTTP_METHOD.DELETE,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteManyVehiculeChecks = async (ids: string[]) => {
  return requestApi({
    url: `${VEHICULE_CHECK_URI}/deleteMany`,
    method: HTTP_METHOD.DELETE,
    body: ids,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
